export { default } from './DepartmentList.js';